import React from 'react';
import { Flex } from 'antd';
import { FormikProps } from 'formik';

import { renderField } from '../../promocodes/utils/fields';
import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../shops/store/shopSlice';
import { getVisibleFields } from '../utils/fields';
import { ApiKeysDTO } from '../service/apiKeys.interface';

export const ApiKeysForm = ({
    formik,
}: {
    formik: FormikProps<ApiKeysDTO>;
}) => {
    const { type } = useAppSelector(selectShopCurrent);

    return (
        <form>
            <Flex vertical style={{ width: 326 }} gap={24}>
                {getVisibleFields(type).map(field => (
                    <React.Fragment key={field.name}>
                        {renderField(field, formik)}
                    </React.Fragment>
                ))}
            </Flex>
        </form>
    );
};
